import { getData, postData,convertPageModel } from './api-base.service'

export const getSchoolHot = (schoolHotId) => {
    var result = getData('/SchoolHot/Get', { id:schoolHotId });
    return result;
}

export const saveSchoolHot = (title, description, linkUrl, pictureUrl, enable, top,fileId, source, isPushNotification, universityIds) => {
    let universities = [];
    universityIds.forEach(id => {
        universities.push({
            Key: id,
            Value: null
        });
    });
    let data = {
        Title: title,
        Description: description,
        PictureUrl:pictureUrl,
        LinkUrl:linkUrl,
        Enable: enable,
        Top:top,
        FileId:fileId,
        Source:source,
        IsPushNotification:isPushNotification,
        Universities: universities
    };
    return postData('/SchoolHot/Save', data);;
}


export const updateSchoolHot = (id,title, description, linkUrl ,pictureUrl, enable, top,fileId, source, isPushNotification, universityIds) => {
    let universities = [];
    universityIds.forEach(id => {
        universities.push({
            Key: id,
            Value: null
        });
    });
    let data = {
        Id:id,
        Title: title,
        Description: description,
        PictureUrl:pictureUrl,
        LinkUrl:linkUrl,
        Enable: enable,
        Top: top,
        FileId:fileId,
        Source:source,
        IsPushNotification:isPushNotification,
        Universities: universities
    };
    return postData('/SchoolHot/Update', data);;
}

export const deleteSchoolHot= (id) => {
    var result = getData('/SchoolHot/Delete', { id: id });
    return result;
}

export const getSchoolHotPageList = (model) => {
    let data  = convertPageModel(model);
    let result = postData('/SchoolHot/GetSchoolHots',data);
    return result;
  }





// WEBPACK FOOTER //
// ./src/service/schoolHot.service.js